import { FC } from "react";

import {
  BaseComponentProps,
  KLanguageSwitcher as KLanguageSwitcherComponent,
} from "@keepeek/refront-components";
import { SelectChangeEvent } from "@mui/material";
import { useRouter } from "next/router";

import { useUILocals } from "../../providers/config/hooks/useUILocals";
import { handleChangeLanguage } from "./utils";

export type KLanguageSwitcher = { color?: string } & BaseComponentProps;

const KLanguageSwitcher: FC<React.PropsWithChildren<KLanguageSwitcher>> = function (props, color) {
  const { locale: currentLocale, pathname, asPath, query, push } = useRouter();

  const resolvedLocales = useUILocals();

  const onChangeLanguage = (locale) =>
    handleChangeLanguage(locale, () => push({ pathname, query }, asPath, { locale }));

  return (
    <KLanguageSwitcherComponent
      currentLocale={currentLocale || ""}
      locales={resolvedLocales}
      onChange={function (event: SelectChangeEvent<string>): void {
        onChangeLanguage(event.target.value);
      }}
      color={color}
      {...props}
    />
  );
};

export function showKLanguageSwitcher(locales: string[] | undefined): boolean {
  return (locales && locales.length > 1) || false;
}

export default KLanguageSwitcher;
